module.exports = __webpack_public_path__ + "static/media/shopping-cart.1cebc951.svg";